import React, { useState, useContext } from 'react';
import { IonContent, IonHeader, IonTitle, IonToolbar, IonItem, IonList, IonSplitPane, IonMenuButton, IonButton, IonButtons, IonInput, IonModal, IonGrid, IonRow, IonCol, IonSlides } from '@ionic/react';
import { IonTabs, IonTabBar, IonTabButton, IonText, IonLabel, IonFooter, IonSlide, IonImg, IonRouterOutlet } from '@ionic/react';
import { Redirect} from 'react-router-dom';

import '../../../css/zsavaApp.css';
import { IonReactRouter } from '@ionic/react-router';
import { Route, Switch } from 'react-router';
//import { IonReactRouter } from '@ionic/react-router';
//import { BrowserRouter } from "react-router-dom";

import { Auth_Zasava_Context } from '../../../storeState/Auth_Zasava_Context'

import { Tab_Management_Inventory } from './Tab_Management_Inventory';
import { Tab_Management_Employee } from './Tab_Management_Employee';
import { Tab_Management_Jobs } from './Tab_Management_Jobs';



export function Zasava_Management (props) {

    let authenticated_Zasava_Context = useContext(Auth_Zasava_Context);


    const [acctID, setAcctID] = useState(authenticated_Zasava_Context.acctID);
    const [schema, setSchemaName] = useState(authenticated_Zasava_Context.schema);
    const [employeeID, setEmployeeID] = useState(authenticated_Zasava_Context.employeeID);

//export const AccountSetting: React.FC<accountSettingProps> = (props: any) => {

    //let [acctID, setAcctID] = useState(props.accountID);
    //let [schema, setSchema] = useState(props.schemaName);
    //let [showInvoiceTemplates, setShowInvoiceTemplates] = useState(false);
    //let [showFormTemplates, setShowFormTemplates] = useState(false);



    //alert('In Management ');
    //alert(acctID);
    //alert(authenticated_Zasava_Context.accessRights[0]);
    //alert(authenticated_Zasava_Context.device);
    //alert(schema);

    return (
            <React.Fragment>

            <IonModal isOpen={true}>


            <IonHeader className='grid_header'>
                        <h3> Management </h3>
            </IonHeader>

            <IonContent className='grid_content'>
                <IonTabs >

                    <IonRouterOutlet>
                        <Route path='/zasava_management/inventoryTab' exact={true} render={() => <Tab_Management_Inventory  accountID={ acctID } employeeID={ employeeID } schemaName={ schema } />} />
                        <Route path='/zasava_management/employeeTab' exact={true} render={() => <Tab_Management_Employee  />} />
                        <Route path='/zasava_management/jobsTab' exact={true} render={() => <Tab_Management_Jobs  />} />

                    </IonRouterOutlet>


                    <IonTabBar slot='top'>
                        <IonTabButton id='inventoryTab' tab='inventoryTab' href='/zasava_management/inventoryTab'>
                            <IonLabel>Inventory</IonLabel>
                        </IonTabButton>
                        <IonTabButton id='employeeTab' tab='employeeTab' href='/zasava_management/employeeTab'>
                                <IonLabel>Employee</IonLabel>
                            </IonTabButton>
                       <IonTabButton id='jobsTab' tab='jobsTab' href='/zasava_management/jobsTab'>
                                <IonLabel>Jobs</IonLabel>
                            </IonTabButton>
                    </IonTabBar>

                </IonTabs>
            </IonContent >

            <IonFooter className='grid_footer'>
                <IonGrid>
                    <IonRow >
                        <IonCol size='6'>
                            <IonButton onClick={() => props.closeModal()}>Close</IonButton>
                        </IonCol>
                    </IonRow>
                </IonGrid>
            </IonFooter>
            </IonModal>


        </React.Fragment>
    );
};


export default Zasava_Management;